module.exports = __webpack_public_path__ + "static/media/section_9_banner.7a2ad1c7.webp";